// Organisation allowed to see org-restricted UI features (e.g. KYC/Card Status
// dashboard). This is a UI convenience gate only — the backend independently
// enforces the real restriction by name+type, since numeric organisation ids
// can differ across environments.
export const KYC_USERS_ORG_NAME = "Infinite Computer Solutions";

export const isKycUsersOrgAdmin = () => {
  const orgName = localStorage.getItem("orgName");
  if (!orgName) return false;
  return orgName.trim().toLowerCase() === KYC_USERS_ORG_NAME.toLowerCase();
};
